import {
  Builderlyags3ldja2y as Builder,
  Builder3vv3qt9kyowg0 as Builder_0,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.__spin_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__saveParty_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__deleteParty_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__saveSlackIntegration_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__savePin_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__deletePin_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__savePlayer_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__deletePlayer_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__savePairAssignments_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__deletePairAssignments_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__createSecret_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__deleteSecret_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__connectUser_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__disconnectUser_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__saveContribution_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__clearContributions_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__grantSlackAccess_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__grantDiscordAccess_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.__saveBoost_input_1 = (new (Builder())('input')).build_1k0s4u_k$();
        this.type_1 = (new (Builder_0())('Mutation')).build_1k0s4u_k$();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceoymipm3rjnhd,
};
//endregion

//# sourceMappingURL=Mutation.mjs.map
